import { Libraries, useLoadScript } from '@react-google-maps/api';

const GOOGLE_MAP_LIBRARIES: Libraries = ['visualization'];

export function useMapInstance() {
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAP_TOKEN || '',
    libraries: GOOGLE_MAP_LIBRARIES
  });

  return { isLoaded };
}
